import { Theme } from '@mui/material/styles';

export default function ControlLabel(theme: Theme): object {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: '0',
        },
        label: {
          ...theme.typography.body2,
        },
      },
    },
    MuiFormHelperText: {
      defaultProps: {
        component: 'div',
      },
      styleOverrides: {
        root: {
          marginTop: theme.spacing(1),
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.text.disabled,
        },
      },
    },
  };
}
